module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div'), _vm._v(" "), _c('b-button', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.openPreAlert
    }
  }, [_vm._v("Send Pre-Alert Mail Happy")]), _vm._v(" "), _c('b-modal', {
    ref: "pre-alert-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": "FCL Export BL Pre Alert"
    }
  }, [_c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [(_vm.pre_prealert_id != '') ? _c('b-button', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.sendMANIFESTATION
    }
  }, [_vm._v("SEND MANIFESTATION DETAILS")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("AGENT REFERENCE ID")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "VESSEL & VOY"
    },
    model: {
      value: (_vm.preAlertData.agent_reference_id),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "agent_reference_id", $$v)
      },
      expression: "preAlertData.agent_reference_id"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("SHIPPING LINE")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "SHIPPING LINE"
    },
    model: {
      value: (_vm.preAlertData.shippingLine),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "shippingLine", $$v)
      },
      expression: "preAlertData.shippingLine"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("SHIPMENT TYPE")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "SHIPMENT TYPE"
    },
    model: {
      value: (_vm.preAlertData.shipmentType),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "shipmentType", $$v)
      },
      expression: "preAlertData.shipmentType"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("CONSIGNOR")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "CONSIGNOR"
    },
    model: {
      value: (_vm.preAlertData.shipper_name),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "shipper_name", $$v)
      },
      expression: "preAlertData.shipper_name"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("LOAD PORT")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "LOAD PORT"
    },
    model: {
      value: (_vm.preAlertData.portLoad),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "portLoad", $$v)
      },
      expression: "preAlertData.portLoad"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("PLACE OF DELIVERY")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "PLACE OF DELIVERY"
    },
    model: {
      value: (_vm.preAlertData.placeDilievery),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "placeDilievery", $$v)
      },
      expression: "preAlertData.placeDilievery"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("CONTAINER NO.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "CONTAINER NO."
    },
    model: {
      value: (_vm.preAlertData.container_no),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "container_no", $$v)
      },
      expression: "preAlertData.container_no"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("HOUSE BL NO.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "HOUSE BL NO."
    },
    model: {
      value: (_vm.preAlertData.house_bl_no),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "house_bl_no", $$v)
      },
      expression: "preAlertData.house_bl_no"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("MASTER BL NO.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "MASTER BL NO."
    },
    model: {
      value: (_vm.preAlertData.master_bl_no),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "master_bl_no", $$v)
      },
      expression: "preAlertData.master_bl_no"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("VESSEL & VOY")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "VESSEL & VOY"
    },
    model: {
      value: (_vm.preAlertData.vesselVoy),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "vesselVoy", $$v)
      },
      expression: "preAlertData.vesselVoy"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("ETD / SOB DATE")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "ETD / SOB DATE"
    },
    model: {
      value: (_vm.preAlertData.etd_date),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "etd_date", $$v)
      },
      expression: "preAlertData.etd_date"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("ETA DISCHARGE")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "ETA DISCHARGE"
    },
    model: {
      value: (_vm.preAlertData.eta_date),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "eta_date", $$v)
      },
      expression: "preAlertData.eta_date"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("CONSIGNEE")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll
    },
    model: {
      value: (_vm.preAlertData.consignee),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "consignee", $$v)
      },
      expression: "preAlertData.consignee"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("OVERSEAS AGENT")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll
    },
    model: {
      value: (_vm.preAlertData.delieveryAgent),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "delieveryAgent", $$v)
      },
      expression: "preAlertData.delieveryAgent"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "my-4"
  }, [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Upload Master BL")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "placeholder": "Click to Upload Master BL DRAFT",
      "name": "masterUpload",
      "id": "masterUpload",
      "multiple": ""
    },
    on: {
      "selected": function($event) {
        _vm.onFileChangeBlDraft('masterBl')
      }
    },
    model: {
      value: (_vm.preAlertData.masterBlUpload),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "masterBlUpload", $$v)
      },
      expression: "preAlertData.masterBlUpload"
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), (_vm.preAlertData.masterBlUpload != '' && _vm.preAlertData.masterBlUpload != undefined && _vm.preAlertData.masterBlUpload != null) ? _c('b', _vm._l((_vm.preAlertData.masterBlUpload.split(',')), function(item_MB_doc, index_MB_doc) {
    return _c('span', {
      key: index_MB_doc
    }, [(item_MB_doc != '') ? _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.Print(item_MB_doc)
        }
      }
    }, [_vm._v("View Document - " + _vm._s(index_MB_doc + 1))]) : _vm._e(), _vm._v(" "), _c('br')])
  })) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Upload House BL")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "placeholder": "Click to Upload House BL DRAFT",
      "name": "houseUpload",
      "id": "houseUpload",
      "multiple": ""
    },
    on: {
      "selected": function($event) {
        _vm.onFileChangeBlDraft('houseBl')
      }
    },
    model: {
      value: (_vm.preAlertData.houseBlUpload),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "houseBlUpload", $$v)
      },
      expression: "preAlertData.houseBlUpload"
    }
  })], 1), _vm._v(" "), (_vm.preAlertData.houseBlUpload != '' && _vm.preAlertData.houseBlUpload != undefined && _vm.preAlertData.houseBlUpload != null) ? _c('b', _vm._l((_vm.preAlertData.houseBlUpload.split(',')), function(item_HB_doc, index_HB_doc) {
    return _c('span', {
      key: index_HB_doc
    }, [(item_HB_doc != '') ? _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.Print(item_HB_doc)
        }
      }
    }, [_vm._v("View Document - " + _vm._s(index_HB_doc + 1))]) : _vm._e(), _vm._v(" "), _c('br')])
  })) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "justify-content-center"
  }, [_c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": (_vm.preAlertData.condition)
    },
    on: {
      "click": _vm.submitPreAlert
    }
  }, [_vm._v("Send request")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.hidePreAlert
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popBlStageMail",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.openPreAlert
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popMail",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.sendPreAlertMail
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b90cf6a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/prealertMail.vue
// module id = 2664
// module chunks = 0